import { useFormikContext } from 'formik';

import { FormSection } from '@@/form-components/FormSection';
import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';
import { SwitchField } from '@@/form-components/SwitchField';

interface HelmInstallOptionsFormValues {
  helmAtomic?: boolean;
  helmTimeout?: string;
}

export function HelmInstallOptionsSection() {
  const { values, setFieldValue, errors } =
    useFormikContext<HelmInstallOptionsFormValues>();

  return (
    <FormSection title="Install options">
      <div className="form-group">
        <div className="col-sm-12">
          <SwitchField
            checked={values.helmAtomic || false}
            data-cy="edge-stack-helm-atomic-switch"
            name="helmAtomic"
            label="Rollback on failure"
            tooltip="Enables automatic rollback on failure"
            labelClass="col-sm-3 col-lg-2"
            onChange={(value) => setFieldValue('helmAtomic', value)}
          />
        </div>
      </div>

      <FormControl
        label="Timeout"
        errors={errors.helmTimeout}
        tooltip="Time to wait for Helm operations to complete (e.g., 5m0s, 10m, 1h30m). Leave empty to use default timeout."
      >
        <Input
          value={values.helmTimeout || ''}
          onChange={(e) => setFieldValue('helmTimeout', e.target.value)}
          placeholder="e.g. 5m0s"
          data-cy="helm-timeout-input"
        />
      </FormControl>
    </FormSection>
  );
}
